/**
 * A6 slice 3b: routes that render as a full-screen immersive flow on PHONE.
 * MobileDashboardShell suppresses all its chrome (top bar, committee switcher,
 * bottom tab bar) for these routes so the page owns the whole viewport.
 * Distinct from FULL_BLEED_PREFIXES (MainContentRegion) — that governs the
 * desktop content max-width cap, this governs phone shell chrome.
 */
export const IMMERSIVE_PREFIXES = ['/dashboard/turf-maps/new']

export function isImmersiveRoute(pathname: string): boolean {
  return IMMERSIVE_PREFIXES.some((p) => pathname === p || pathname.startsWith(p + '/'))
}
